import { render } from "./index.vue?vue&type=template&id=4d232373&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4d232373&lang=less&scoped=true"

import exportComponent from "/Volumes/Mac_SSD/work_desktop/old-im/webapp-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d232373"]])

export default __exports__